module.exports = "/assets/bb52b73a80cb63d8eb46198261fa9c71.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cars/assets/logos/ZL.png
// module id = 768
// module chunks = 0